import { Suspense, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { DrawerPage } from 'components/DrawerPage';
import { NftViewSkeleton } from './__partials/NftView/Skeleton';
import { isMobile } from 'utils';
import { lazy } from 'utils/generic/lazy';
import { NFT_VIEW_URL_PATTERN } from 'constants/app/route-reserved-words';

const { NftView } = lazy(
  () => import(/* webpackChunkName: "NFT Single View" */ './__partials/NftView')
);

export const NftSingleView = () => {
  const { pathname } = useLocation();

  const showNFTView = useMemo(
    () => NFT_VIEW_URL_PATTERN.test(pathname),
    [pathname]
  );

  const id = useMemo(() => {
    const [, _id] = pathname.match(NFT_VIEW_URL_PATTERN) || [null, null];
    return _id;
  }, [pathname]);

  return (
    <DrawerPage
      open={showNFTView}
      closable={!isMobile()}
      headerStyle={{
        zIndex: 1,
        position: 'fixed',
        top: 0,
        right: 0,
        background: 'transparent',
        padding: '20px 20px 0'
      }}
    >
      <Suspense fallback={<NftViewSkeleton />}>
        <NftView id={id} />
      </Suspense>
    </DrawerPage>
  );
};
